"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContent = exports.StyledWrapper = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
/**
 * Editor scrollbar has 5px width
 * scrollbar margin is 5px
 * sidebar 320px
 * sidebar content 288px
 * sidebar padding left 16px
 * sidebar padding right 10px
 */
/**
 * Padding left|right are hardcoded because of the scrollbar
 */
exports.StyledWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-flow: column;

  ${({ theme }) => (0, styled_components_1.css) `
    width: ${ui_common_components_1.utils.rem(theme.Components.ToolBar.contentContainer -
    (theme.Components.ToolBar.padding -
        theme.Components.Scrollbar.NormalWidth) /
        2)};
    padding-left: ${ui_common_components_1.utils.rem(theme.Components.ToolBar.padding)};
  `}

  height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: ${({ locked }) => (locked ? 'clip' : 'auto')};

  ${({ theme }) => (0, styled_components_1.css) `
    background-color: ${theme.Components.Panel.Background};
    ${theme.Scrollbar.Default}
  `}
`;
exports.StyledContent = styled_components_1.default.div `
  display: flex;
  flex: 1 0 auto;
  flex-flow: column;
  box-sizing: border-box;
  min-height: 100%;

  ${({ theme }) => (0, styled_components_1.css) `
    width: ${ui_common_components_1.utils.rem(theme.Components.ToolBar.contentContainer -
    theme.Components.ToolBar.padding * 2 +
    theme.Components.Scrollbar.NormalWidth)};

    padding: 0
      ${ui_common_components_1.utils.rem(theme.Components.ToolBar.padding -
    theme.Components.Scrollbar.NormalWidth / 2)}
      ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)} 0;

    background-color: ${theme.Components.Panel.Background};
  `}
`;
//# sourceMappingURL=MenuShell.style.js.map